<template>
  <div>
    <div class="body-top">
      <router-link tag="h2" class="pointer" to="/">校园精准服务系统</router-link>
      <p>
        <router-link tag="a" to="/login">登录</router-link>
      </p>
    </div>
    <div class="wrap">
      <h6>校园精准服务系统隐私权政策</h6>
      <p class="update">最近更新时间：2018-03-22</p>
      <br />
      <br />
      <p>校园精准服务系统非常重视您的隐私权。本《隐私权政策》适用于由校园精准服务系统及联盟公司提供的所有产品、服务、网站和平台，统称为校园精准服务系统的“服务”。此外，如有必要对我们的隐私权政策详加说明，我们会张贴增补隐私权通知，说明特定服务处理个人信息（包含您的姓名、联系电话、电子邮件地址等）的方式。</p>
      <br />
      <br />
      <p>如果您不熟悉Cookie、浏览器、API等术语，请先了解有关这些关键术语的信息。如果您对本《隐私权政策》有任何疑问，欢迎随时通过与我们联络。</p>
      <br />
      <br />
      <h1>（一）我们收集的信息类型和使用方式</h1>
      <p>为了向您提供更完善、更优质的服务，我们可能会收集以下信息：</p>
      <br />
      <br />
      <p>1.1 您向我们提供的信息。当您申请校园精准服务系统帐号或其他需要注册的校园精准服务系统服务或促销优惠产品时，我们会要求您提供个人信息 （例如姓名、联系电话、电子邮件地址以及帐户密码）。对于某些服务 （例如我们的广告计划）与增值功能服务（例如会员服务），我们会征得您的同意，并且要求您提供学校信息、身份证件等隐私信息，并会以加密形式储存在安全的服务器上。我们可能会将您通过帐户提交的信息与来自其他 校园精准服务系统服务或第三方的信息合并，以便为您提供更好的使用体验，并改善我们的服务质量。</p>
      <br />
      <br />
      <p>1.2 我们在您使用服务的过程中获取的信息：</p>
      <br />
      <br />
      <div class="item-child">
        <p>1）Cookie信息。您造访校园精准服务系统提供的平台与服务时，我们会将一个或多个 Cookie （包含一串字符的小型档案） 传送到您的计算机或其他装置上，以便识别您的浏览器。我们使用 Cookie 来储存使用者偏好设定，改善搜寻结果，保持您操作接口与流程的一致性以及追踪使用者趋势，以提升服务质量。</p>
        <br />
        <br />
        <p>2）日志信息。您使用校园精准服务系统服务时，我们的服务器会在您造访网站时自动记录浏览器所传送的信息。服务器日志可能包含您的网页请求、因特网通讯协议地址、浏览器类型、浏览器语言、传送请求的日期和时间，以及一个或多个用来识别您浏览器的 Cookie 等信息。</p>
        <br />
        <br />
        <p>3）链接信息。校园精准服务系统可能会以特定格式显示链接，以便追踪用户是否连上了这些链接。我们使用此信息来改善定制化内容和推荐的质量以及我们的服务精准度。</p>
        <br />
        <br />
        <p>4）校园精准服务系统仅对用户的信息与资料进行形式审查，不进行实质性审查（实质性审查包括但不限于鉴别、核实任何登记资料的真实性、正确性以及是否为最新资料的审查）对此所产生的纠纷校园精准服务系统不承担过错责任。</p>
        <br />
        <br />
        <p>5）您向校园精准服务系统联盟网站提供的信息。我们会通过其他网站提供某些服务。您提供给这些网站的个人信息可能会传送给校园精准服务系统，以便我们提供服务之用。我们会根据本《隐私权政策》处理此类信息。提供校园精准服务系统服务的联盟网站所采用的隐私权政策与我们的政策不尽相同，建议您详阅他们的隐私权政策。</p>
        <br />
        <br />
      </div>
      <p>1.3 本《隐私权政策》仅适用于校园精准服务系统所提供之服务。对于平台上搜寻出的主办方首页，主办方私自拥有的网站，主办方提供的促销活动、优惠券信息、电子档案、超链接等，我们并无控制权。这些来源可能会在您的计算机上放置自己的 Cookie 或其他档案，以收集数据或要求您提供个人信息。</p>
      <br />
      <br />
      <p>1.4 校园精准服务系统处理个人信息时，会严格遵守本《隐私权政策》和/或特定服务之增补隐私权通知所述的用途。除了上述项目之外，此类用途还包括：</p>
      <br />
      <br />
      <div class="item-child">
        <p>1）对使用者、开发者提供或部分提供我们的服务；</p>
        <br />
        <br />
        <p>2）对信息进行核查、研究、分析，以便维护、保护及改善我们的服务质量；</p>
        <br />
        <br />
        <p>3）保护校园精准服务系统或校园精准服务系统使用者的权利或财产；</p>
        <br />
        <br />
        <p>4）开发、提供校园精准服务系统新服务</p>
        <br />
        <br />
      </div>
      <p>您可以参阅特定服务的增补隐私权通知，了解更多关于我们处理个人信息的方式。</p>
      <br />
      <br />
      <p>1.5 校园精准服务系统使用位于北京的服务器处理个人信息。在某些情况下，我们会使用位于您所在的国家/地区以外的服务器来处理个人信息。校园精准服务系统可能会处理个人信息以便提供我们的服务。在某些情况下，我们可能会根据第三方 （例如战略合作伙伴或开放性平台） 的指示为其处理个人信息。</p>
      <br />
      <br />
      <h1>（二）个人信息的选择</h1>
      <p>2.1 当您申请需要注册的特定服务时，我们会要求您提供个人信息。如果此信息的使用方式与当初收集的目的不同，我们会在使用前先征求您的同意。</p>
      <br />
      <br />
      <p>2.2 如果个人信息的使用用途与本《隐私权政策》和/或特定服务的隐私权通知所述不同，我们将提供有效的方法，让您选择不将个人信息用于这些用途。除非已事先征得您的同意，否则我们不会收集敏感信息或将之用于本《隐私权政策》和/或增补服务隐私权通知未涉及之目的。</p>
      <br />
      <br />
      <p>2.3 大部分浏览器都预设为接受 Cookie，但您可以重设浏览器以停用所有 Cookie，或在 Cookie 传送时显示通知。不过，如果您停用了 Cookie，某些校园精准服务系统功能和服务可能无法正常运作。</p>
      <br />
      <br />
      <p>2.4 您可以拒绝向任何校园精准服务系统服务提交个人信息，不过我们可能也因此无法为您提供某些服务。此外，校园精准服务系统提供之服务平台包含部分公开讨论信息（例如评论区域、留言板等），可自由输入任何文字或上传图片以供网友互动。此类型行为我们并无权控制， 因此您所填写的数据可能经由其他有心人士利用，请您特别注意个人信息的妥善保护。</p>
      <br />
      <br />
      <h1>（三）信息分享</h1>
      <p>校园精准服务系统只会在以下少数情况下，与校园精准服务系统以外的其他公司或个人分享个人信息，其前提为：</p>
      <br />
      <br />
      <div class="item-child">
        <p>1）已事先征得您的同意。分享机密的个人信息前，我们都会先征求使用者同意。</p>
        <br />
        <br />
        <p>2）我们将此类信息提供给合作伙伴或其他可信赖的企业或人员，让他们为校园精准服务系统处理个人信息。我们要求当事人同意根据我们的指示处理此类信息，并遵守本《隐私权政策》和其他适用的任何保密和安全措施。</p>
        <br />
        <br />
        <p>3）我们坚信基于下列因素，存取、使用、保存或披露此类信息是合理且必要的： (a) 遵循所有适用法律、法规、法律程序或具法律效力的政府要求， (b) 强制执行适用的《服务条款》，包括对潜在违规行为展开调查， (c) 侦查、防止或以其它方式解决诈骗、安全性或技术问题，或 (d) 依法律规定或在法律允许范围内，保护校园精准服务系统及其使用者或大众的权利、财产或安全。。</p>
        <br />
        <br />
        <p>4）如果校园精准服务系统参与合并、收购事宜，或以任何方式出售其部分或全部财产，我们将确保对涉及这些交易的所有个人信息保密，并在个人信息移转且被另一隐私权政策约束之前通知您。</p>
        <br />
        <br />
      </div>
      <p>我们可能与第三方分享部份汇总的非个人信息，例如曾经搜寻特定字词的使用者人数，或是曾经点击特定链接的使用者人数。此类信息并不会暴露您的个人身份。</p>
      <br />
      <br />
      <h1>（四）信息安全</h1>
      <p>4.1 我们会采取适当的安全措施，来防止未经授权的数据存取、篡改、披露或损毁，其中包括就资料的收集、储存、处理惯例和安全措施进行内部审查，以及实体的安全措施，以防止我们储存个人资料的系统遭到未经授权的存取。</p>
      <br />
      <br />
      <p>4.2 我们只允许校园精准服务系统的员工、承包商和代理人存取个人资料，因为他们需要这些信息来提供、开发或改善我们的服务。上述人员都必须遵守保密义务，否则可能会遭到惩戒，包括解雇和刑事起诉等。</p>
      <br />
      <br />
      <h1>（五）数据正确性</h1>
      <p>校园精准服务系统 处理个人信息时，会严格遵守当初收集信息的目的以及本《隐私权政策》或任何适用的特定服务隐私权通知。我们会审查我们的资料收集、储存和处理惯例，以确保仅收集、储存和处理提供或改善我们的服务所需的个人信息。我们会采取合理的措施来确保所处理之个人信息的正确性、完整性和实时性，但我们仰赖使用者在必要时更新或修正其个人信息。</p>
      <br />
      <br />
      <h1>（六）查阅和更新个人信息</h1>
      <p>当您使用校园精准服务系统服务时，我们会尽量让您有权查阅自己的个人信息，并让您修正不正确的信息，或依您的要求，将法律并未规定需要保留或依合法商业用途不需保留的数据删除。处理此类要求之前，我们会要求个别使用者证明身份，并指明要查阅、修正或移除的信息，我们可能会拒绝处理过度重复、经常性、需要过多技术支持、危害其他使用者隐私权、 非常不切实际 （例如索取储存于备份磁带上的信息） 或是根本不必要的查阅要求。除非需要大量的技术支持，否则我们会免费让使用者查阅和修正自己的个人信息。我们有部份服务采用不同的程序来查阅、修正或删除用户个人信息。如需这些程序的详细信息，请参阅此等服务的特定隐私权通知或常见问题。</p>
      <br />
      <br />
      <h1>（七）执行</h1>
      <p>校园精准服务系统 会定期审查其网站是否遵守本《隐私权政策》。如果您对本《隐私权政策》或校园精准服务系统处理个人信息的方式有任何疑问，欢迎随时通过校园精准服务系统网站与我们联络或发送E-Mail至服务信箱。上述地址收到正式的书面申诉后，我们会根据校园精准服务系统的政策与提交申诉的使用者联络，处理相关事宜。我们会与适当的法律机构（包括当地的数据保护机构）合作，以解决校园精准服务系统与申诉者之间无法解决的有关个人资料移转的申诉问题。</p>
      <br />
      <br />
      <h1>（八）本隐私权政策的变更</h1>
      <p>请注意，本《隐私权政策》会不时变更。但我们不会在未经您同意的情况下，削减本《隐私权政策》赋予您的权利。即使有变更，多半也只是小幅修正。无论如何，我们会将《隐私权政策》的所有变更都张贴在此网页上，如果是重大变更，我们将提供更明确的通知。</p>
      <br />
      <br />
      <p>
        如果您有其他任何关于本《隐私权政策》的问题或疑虑，欢迎随时通过此网站与我们联络或E-Mail至服务信箱
        <a
          class="tomail"
          href="mailto:nauac@nauac.com?subject=%E5%85%B3%E4%BA%8E%E3%80%8A%E9%9A%90%E7%A7%81%E6%9D%83%E6%94%BF%E7%AD%96%E3%80%8B%E7%9A%84%E7%96%91%E9%97%AE"
        >nauac@nauac.com</a>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>
<script>
export default {
  name: 'userprivcy'
}
</script>
<style scoped>
h1 {
  font-size: 24px;
  line-height: 24px;
  margin: 25px auto;
  text-align: left;
  font-weight: bolder;
}

p {
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 1px;
}

h2 {
  font-size: 16px;
  line-height: 50px;
  font-weight: bolder;
}

h6 {
  font-size: 30px;
  font-weight: 300;
  padding: 20px 0;
  text-align: center;
}

.wrap {
  margin: auto;
  max-width: 800px;
  text-align: justify;
  padding: 25px 80px;
  background: #fff;
}

@media screen and (max-width: 1000px) {
  .wrap {
    padding: 25px;
  }
  .logo {
    margin-left: 25px;
  }
}

.update {
  font-size: 12px !important;
  color: #9c9c9c;
  font-weight: 300 !important;
  text-align: center;
}

a.tomail {
  color: #0085ff;
  text-decoration: underline;
}

.item-child {
  padding: 0 25px;
}

.container {
  max-width: 960px;
  margin: auto;
  padding-top: 10px;
}

.logo {
  display: inline-block;
  cursor: pointer;
  height: 30px;
  width: 48px;
  /* background-image: url(../../img/logo-01.png); */
  background-size: cover;
  background-position: center;
}

.nav {
  width: 100%;
  height: 70px;
  line-height: 70px;
  background: #fff;
  box-shadow: 0px 2px 3px -2px #ccc;
  z-index: 2;
  margin-bottom: 2px;
}
#app {
  background: #f6f6f6;
}
.body-top {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px;
  background: #fff;
  box-shadow: 0 -3px 6px 0 rgba(221, 221, 221, 0.7);
}

.body-top h2 {
  font-size: 15px;
  font-weight: bold;
}

.body-top a {
  color: #2178ec;
  font-size: 12px;
}

.body-top {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px;
  background: #fff;
  box-shadow: 0 -3px 6px 0 rgba(221, 221, 221, 0.7);
  margin-bottom: 4px;
}

.body-top h2 {
  font-size: 15px;
  font-weight: bold;
}

.body-top a {
  color: #2178ec;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/protocol/userprivcy.vue